jQuery(document).ready(function ($) {
    window.tid = 0;
    window.remodel = 0;
    window.offset = 120;
    window.menu_classname = '.all-products-container .product-collection';
    window.smooth_scroll_regex = /\/pages\/my-order\/[^#]*\#([^\?\/]+)/gm;
    window.collection_regex = /\/collections\/([\w-_]+)/gm;
    window.download_menu_regex = /\/([^\.]+.pdf)/gm;
    window.smooth_scroll_regex.lastIndex = 0;

    const is_collection_page = ($(window.menu_classname).length > 0);
    const is_new_collection_page = $('.all-products-container').hasClass('collection-page');

    remove_duplicate_option_form();

    function remove_duplicate_option_form() {
        var ids = [];

        $('.js-forms .product_form_options').each(function () {
            var id = $(this).attr('id');

            if (jQuery.inArray(id, ids)) {
                ids.push(id);
            }
            else {
                $(this).remove();
            }
        });
    }

    $(".remodal-wrapper .remodal").after('<div id="scroll-focus"></div>');

    $(document).on('opening', '.remodal', function (e) {
        $('#scroll-focus').addClass('show');
        window.remodel = setInterval(isRemodalFullyLoaded, 20);
    });

    $(document).on('closed', '.remodal', function () {
        clearInterval(window.remodel);
    });

    function isRemodalFullyLoaded() {
        var height = parseInt($(".remodal-wrapper .remodal .flickity-viewport").css('height'));
        if (height > 280) {
            clearInterval(window.remodel);
            $('#scroll-focus').removeClass('show');
        }
    }

    if (is_new_collection_page) {
        $('body').addClass('collection-page');
    }
    else {
        $('.main-content > h3').each(function () {

            var anchor = $(this).html().toLowerCase().replace(/\s/g, '-');;

            if (anchor.length <= 0) return;

            $(this).addClass('smooth-scroll-anchor');
            $(this).addClass(anchor);

        });

        $('.footer_menu li a, .main_nav .sub-menu li a').each(function () {

            var anchor = window.smooth_scroll_regex.exec($(this).attr('href'));
            window.smooth_scroll_regex.lastIndex = 0;

            var is_my_order_link = (anchor != null && anchor.length > 1 && anchor[1].length > 0);

            if (is_collection_page) {
                var collection_anchor = window.collection_regex.exec($(this).attr('href'));
                window.collection_regex.lastIndex = 0;
                var is_collection_link = (collection_anchor != null && collection_anchor.length > 1 && collection_anchor[1].length > 0);
            }

            if (is_my_order_link) {
                $(this).data('anchor', anchor[1]);

                $(this).click(function () {

                    var anchor = $('.smooth-scroll-anchor.' + $(this).data('anchor'));

                    if (anchor.length <= 0) return;

                    $.smoothScroll({
                        offset: -window.offset,
                        scrollTarget: anchor,
                    });

                    return false;

                });
            }
            else if (is_collection_page && is_collection_link) {
                // $(this).data('anchor', collection_anchor[1]);
                // $(this).attr('href', '#'+collection_anchor[1]);

                // $(this).click(function(){

                //   var anchor = $('.collection-handle.' + $(this).data('anchor'));

                //   if(anchor.length <= 0) return;

                //   $.smoothScroll({
                //     offset: -window.offset,
                //     scrollTarget: anchor,
                //   });

                //   return false;

                // });
            }
            else {
                var download_menu = window.download_menu_regex.exec($(this).attr('href'));
                window.download_menu_regex.lastIndex = 0;

                if (download_menu != null && download_menu.length > 1 && download_menu[1].length > 0) {
                    $(this).attr('target', '_blank');
                }
            }


        });

        var anchor = window.smooth_scroll_regex.exec(window.location.href);

        if (anchor != null && anchor.length > 1) {
            anchor = $('.smooth-scroll-anchor.' + anchor[1]);

            if (anchor.length <= 0) return;

            $.smoothScroll({
                offset: -window.offset,
                scrollTarget: anchor,
            });
        }
    }

    if ($($('.shopify-section')[1]).find('.banner-slideshow').length <= 0) {
        $('body').addClass('no-banner');
    }
    else {
        $('body').addClass('has-banner');
    }

    $('body').removeClass('loading');

    // $('.cart_items .cart_item input[type="number"]').prop('disabled', true);


    $('#cart_form .product-remove').click(function () {
        var parent = $(this).parent().parent();
        var input = parent.find('input');
        input.prop('min', 0);
        input.val(1);
        parent.find('.product-minus').click();
    });

    window.set_remove_button = function () {
        var input = $(this).parent().find('input');
        input.prop('min', 0);
        input.val(1);
        $(this).parent().find('.product-minus').click();
    }

    $('.cart_content .cart_item .product-remove').click(window.set_remove_button);

    var accordions = $('body .container .accordions-container ul.accordions > li');

    accordions.addClass('close');
    accordions.find('ul').slideUp(0);
    accordions.first().find('ul').slideDown(0);
    accordions.first().removeClass('close');
    accordions.first().removeClass('close');
    accordions.addClass('accordion');

    accordions.click(function () {
        $(this).toggleClass('close');
        $(this).find('ul').slideToggle(300);
    });

    if (is_collection_page) {
        window.collection_regex.lastIndex = 0;
        var href = window.collection_regex.exec(window.location.href);
        window.collection_regex.lastIndex = 0;

        if (!is_new_collection_page && href != null && href.length > 1 && href[1].length > 0) {
            $.smoothScroll({
                offset: (-window.offset),
                scrollTarget: $('.collection-handle.' + href[1]),
            });
        }

        if (!is_new_collection_page) {
            $(window.menu_classname + ' span').click(function () {
                var parent = $(this).parent();

                parent.find('.menu-button').click();

                $.smoothScroll({
                    offset: (-window.offset),
                    scrollTarget: $('#cat' + $(this).data('id')),
                });
            });

            // $(window.menu_classname + ' span').first().click();
        }

        $(window.menu_classname + ' .menu-button').click(function () {
            var parent = $(this).parent();

            if (parent.hasClass('close')) {
                openMenu(parent);
            }
            else {
                closeMenu(parent);
            }

            return false;
        });

        $(window.menu_classname + ' ul').each(function () {
            var parent = $(this).parent();

            calHeight(parent);
            parent.addClass('close');
            parent.find('ul').slideUp(0);
            updateMenuPosition();
        });

        $(window).scroll(function () {
            updateMenuPosition();
        });

        function calHeight(menu) {
            var height = menu.outerHeight();
            menu.data('height', height);
        }

        function closeMenu(menu) {
            if (menu.hasClass('close')) return;

            closeSubMenu(menu);
        }

        function openMenu(menu) {
            if (!menu.hasClass('close')) return;

            menu.addClass('current');

            $(window.menu_classname).each(function () {
                if ($(this).hasClass('current')) {
                    $(this).removeClass('current');
                    openSubMenu($(this));
                }
                else {
                    closeSubMenu($(this));
                }
            });
        }

        function updateMenuPosition() {
            const offset = 75;
            const has_slide = ($('.banner-slideshow').length > 0);

            var menus = $('.all-products-container .sidebar-menu');

            if (menus.css('top') == '-1000px') return;

            var slideshowsize = offset + 70;

            if (has_slide)
                slideshowsize = $('.banner-slideshow').outerHeight() + offset;

            var csstop = -78;
            var container = $('.all-products-container');

            if (container.length <= 0) return;

            var border = container.offset().top + container.outerHeight() - menus.outerHeight() - csstop;
            var scroll = $(window).scrollTop();

            if (scroll > border) {
                menus.addClass('bottom');
                menus.removeClass('fixed');
            }
            else if (scroll > slideshowsize) {
                menus.addClass('fixed');
                menus.removeClass('bottom');
            }
            else {
                menus.removeClass('fixed');
                menus.removeClass('bottom');
            }
        }

        function openSubMenu(menu) {
            menu.removeClass('close');
            menu.find('ul').slideDown(300, clearTimer);

            window.tid = setInterval(updateMenuPosition, 10);
        }

        function closeSubMenu(menu) {
            menu.addClass('close');
            menu.find('ul').slideUp(300, clearTimer);

            window.tid = setInterval(updateMenuPosition, 10);
        }

        function clearTimer() {
            clearTimeout(window.tid);
        }
    }
});

jQuery(document).ready(function ($) {
    const is_new_collection_page = $('.all-products-container').hasClass('collection-page');

    if (is_new_collection_page) {
        $('body').addClass('collection-page');
        $('.sidebar-menu .product-collection span').unbind();

        if ($('.no-banner .shopify-section:nth-child(2)').length > 0) {
            $.smoothScroll({
                offset: 1,
                speed: 1,
            });
            $('body').addClass('active');
        }
    }
});







// ====================================================
// Additional JS Libs
// ====================================================









(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var version = '2.2.0';
    var optionOverrides = {};
    var defaults = {
        exclude: [],
        excludeWithin: [],
        offset: 0,

        // one of 'top' or 'left'
        direction: 'top',

        // if set, bind click events through delegation
        //  supported since jQuery 1.4.2
        delegateSelector: null,

        // jQuery set of elements you wish to scroll (for $.smoothScroll).
        //  if null (default), $('html, body').firstScrollable() is used.
        scrollElement: null,

        // only use if you want to override default behavior
        scrollTarget: null,

        // automatically focus the target element after scrolling to it
        autoFocus: false,

        // fn(opts) function to be called before scrolling occurs.
        // `this` is the element(s) being scrolled
        beforeScroll: function () { },

        // fn(opts) function to be called after scrolling occurs.
        // `this` is the triggering element
        afterScroll: function () { },

        // easing name. jQuery comes with "swing" and "linear." For others, you'll need an easing plugin
        // from jQuery UI or elsewhere
        easing: 'swing',

        // speed can be a number or 'auto'
        // if 'auto', the speed will be calculated based on the formula:
        // (current scroll position - target scroll position) / autoCoeffic
        speed: 400,

        // coefficient for "auto" speed
        autoCoefficient: 2,

        // $.fn.smoothScroll only: whether to prevent the default click action
        preventDefault: true
    };

    var getScrollable = function (opts) {
        var scrollable = [];
        var scrolled = false;
        var dir = opts.dir && opts.dir === 'left' ? 'scrollLeft' : 'scrollTop';

        this.each(function () {
            var el = $(this);

            if (this === document || this === window) {
                return;
            }

            if (document.scrollingElement && (this === document.documentElement || this === document.body)) {
                scrollable.push(document.scrollingElement);

                return false;
            }

            if (el[dir]() > 0) {
                scrollable.push(this);
            } else {
                // if scroll(Top|Left) === 0, nudge the element 1px and see if it moves
                el[dir](1);
                scrolled = el[dir]() > 0;

                if (scrolled) {
                    scrollable.push(this);
                }
                // then put it back, of course
                el[dir](0);
            }
        });

        if (!scrollable.length) {
            this.each(function () {
                // If no scrollable elements and <html> has scroll-behavior:smooth because
                // "When this property is specified on the root element, it applies to the viewport instead."
                // and "The scroll-behavior property of the … body element is *not* propagated to the viewport."
                // → https://drafts.csswg.org/cssom-view/#propdef-scroll-behavior
                if (this === document.documentElement && $(this).css('scrollBehavior') === 'smooth') {
                    scrollable = [this];
                }

                // If still no scrollable elements, fall back to <body>,
                // if it's in the jQuery collection
                // (doing this because Safari sets scrollTop async,
                // so can't set it to 1 and immediately get the value.)
                if (!scrollable.length && this.nodeName === 'BODY') {
                    scrollable = [this];
                }
            });
        }

        // Use the first scrollable element if we're calling firstScrollable()
        if (opts.el === 'first' && scrollable.length > 1) {
            scrollable = [scrollable[0]];
        }

        return scrollable;
    };

    var rRelative = /^([\-\+]=)(\d+)/;

    $.fn.extend({
        scrollable: function (dir) {
            var scrl = getScrollable.call(this, { dir: dir });

            return this.pushStack(scrl);
        },
        firstScrollable: function (dir) {
            var scrl = getScrollable.call(this, { el: 'first', dir: dir });

            return this.pushStack(scrl);
        },

        smoothScroll: function (options, extra) {
            options = options || {};

            if (options === 'options') {
                if (!extra) {
                    return this.first().data('ssOpts');
                }

                return this.each(function () {
                    var $this = $(this);
                    var opts = $.extend($this.data('ssOpts') || {}, extra);

                    $(this).data('ssOpts', opts);
                });
            }

            var opts = $.extend({}, $.fn.smoothScroll.defaults, options);

            var clickHandler = function (event) {
                var escapeSelector = function (str) {
                    return str.replace(/(:|\.|\/)/g, '\\$1');
                };

                var link = this;
                var $link = $(this);
                var thisOpts = $.extend({}, opts, $link.data('ssOpts') || {});
                var exclude = opts.exclude;
                var excludeWithin = thisOpts.excludeWithin;
                var elCounter = 0;
                var ewlCounter = 0;
                var include = true;
                var clickOpts = {};
                var locationPath = $.smoothScroll.filterPath(location.pathname);
                var linkPath = $.smoothScroll.filterPath(link.pathname);
                var hostMatch = location.hostname === link.hostname || !link.hostname;
                var pathMatch = thisOpts.scrollTarget || (linkPath === locationPath);
                var thisHash = escapeSelector(link.hash);

                if (thisHash && !$(thisHash).length) {
                    include = false;
                }

                if (!thisOpts.scrollTarget && (!hostMatch || !pathMatch || !thisHash)) {
                    include = false;
                } else {
                    while (include && elCounter < exclude.length) {
                        if ($link.is(escapeSelector(exclude[elCounter++]))) {
                            include = false;
                        }
                    }

                    while (include && ewlCounter < excludeWithin.length) {
                        if ($link.closest(excludeWithin[ewlCounter++]).length) {
                            include = false;
                        }
                    }
                }

                if (include) {
                    if (thisOpts.preventDefault) {
                        event.preventDefault();
                    }

                    $.extend(clickOpts, thisOpts, {
                        scrollTarget: thisOpts.scrollTarget || thisHash,
                        link: link
                    });

                    $.smoothScroll(clickOpts);
                }
            };

            if (options.delegateSelector !== null) {
                this
                    .off('click.smoothscroll', options.delegateSelector)
                    .on('click.smoothscroll', options.delegateSelector, clickHandler);
            } else {
                this
                    .off('click.smoothscroll')
                    .on('click.smoothscroll', clickHandler);
            }

            return this;
        }
    });

    var getExplicitOffset = function (val) {
        var explicit = { relative: '' };
        var parts = typeof val === 'string' && rRelative.exec(val);

        if (typeof val === 'number') {
            explicit.px = val;
        } else if (parts) {
            explicit.relative = parts[1];
            explicit.px = parseFloat(parts[2]) || 0;
        }

        return explicit;
    };

    var onAfterScroll = function (opts) {
        var $tgt = $(opts.scrollTarget);

        if (opts.autoFocus && $tgt.length) {
            $tgt[0].focus();

            if (!$tgt.is(document.activeElement)) {
                $tgt.prop({ tabIndex: -1 });
                $tgt[0].focus();
            }
        }

        opts.afterScroll.call(opts.link, opts);
    };

    $.smoothScroll = function (options, px) {
        if (options === 'options' && typeof px === 'object') {
            return $.extend(optionOverrides, px);
        }
        var opts, $scroller, speed, delta;
        var explicitOffset = getExplicitOffset(options);
        var scrollTargetOffset = {};
        var scrollerOffset = 0;
        var offPos = 'offset';
        var scrollDir = 'scrollTop';
        var aniProps = {};
        var aniOpts = {};

        if (explicitOffset.px) {
            opts = $.extend({ link: null }, $.fn.smoothScroll.defaults, optionOverrides);
        } else {
            opts = $.extend({ link: null }, $.fn.smoothScroll.defaults, options || {}, optionOverrides);

            if (opts.scrollElement) {
                offPos = 'position';

                if (opts.scrollElement.css('position') === 'static') {
                    opts.scrollElement.css('position', 'relative');
                }
            }

            if (px) {
                explicitOffset = getExplicitOffset(px);
            }
        }

        scrollDir = opts.direction === 'left' ? 'scrollLeft' : scrollDir;

        if (opts.scrollElement) {
            $scroller = opts.scrollElement;

            if (!explicitOffset.px && !(/^(?:HTML|BODY)$/).test($scroller[0].nodeName)) {
                scrollerOffset = $scroller[scrollDir]();
            }
        } else {
            $scroller = $('html, body').firstScrollable(opts.direction);
        }

        // beforeScroll callback function must fire before calculating offset
        opts.beforeScroll.call($scroller, opts);

        scrollTargetOffset = explicitOffset.px ? explicitOffset : {
            relative: '',
            px: ($(opts.scrollTarget)[offPos]() && $(opts.scrollTarget)[offPos]()[opts.direction]) || 0
        };

        aniProps[scrollDir] = scrollTargetOffset.relative + (scrollTargetOffset.px + scrollerOffset + opts.offset);

        speed = opts.speed;

        // automatically calculate the speed of the scroll based on distance / coefficient
        if (speed === 'auto') {

            // $scroller[scrollDir]() is position before scroll, aniProps[scrollDir] is position after
            // When delta is greater, speed will be greater.
            delta = Math.abs(aniProps[scrollDir] - $scroller[scrollDir]());

            // Divide the delta by the coefficient
            speed = delta / opts.autoCoefficient;
        }

        aniOpts = {
            duration: speed,
            easing: opts.easing,
            complete: function () {
                onAfterScroll(opts);
            }
        };

        if (opts.step) {
            aniOpts.step = opts.step;
        }

        if ($scroller.length) {
            $scroller.stop().animate(aniProps, aniOpts);
        } else {
            onAfterScroll(opts);
        }
    };

    $.smoothScroll.version = version;
    $.smoothScroll.filterPath = function (string) {
        string = string || '';

        return string
            .replace(/^\//, '')
            .replace(/(?:index|default).[a-zA-Z]{3,4}$/, '')
            .replace(/\/$/, '');
    };

    // default options
    $.fn.smoothScroll.defaults = defaults;

}));